import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const LandingHeader = () => {
    return (
        <header className="sticky top-0 z-50 w-full border-b border-slate-200/60 bg-[#EAE8E4]/90 backdrop-blur-md supports-[backdrop-filter]:bg-[#EAE8E4]/80">
            <div className="max-w-7xl mx-auto flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">

                {/* Logo */}
                <div className="flex flex-col items-start py-2">
                    <Link to="/" className="flex flex-col items-start group">
                        <img
                            src="/assets/logo.png"
                            alt="Hafani Logo"
                            className="h-10 w-auto object-contain transition-transform group-hover:scale-105"
                        />
                        <span className="text-[9px] sm:text-[10px] text-emerald-700 font-medium leading-tight mt-0.5 tracking-wide">
                            Hafani, une solution pensée pour notre fin
                        </span>
                    </Link>
                </div>

                {/* Right — dual CTA */}
                <div className="flex items-center gap-3">
                    <Button
                        asChild
                        variant="ghost"
                        className="hidden sm:inline-flex text-slate-700 hover:text-slate-900 hover:bg-white/60 rounded-full px-5 text-sm font-medium tracking-wide transition-all duration-200"
                    >
                        <Link to="/login">Espace Particuliers</Link>
                    </Button>
                    <Button
                        asChild
                        className="bg-slate-900 text-white hover:bg-emerald-800 rounded-full px-5 sm:px-6 text-sm font-medium tracking-wide shadow-sm transition-all duration-200"
                    >
                        <Link to="/admin/login">Espace Associations</Link>
                    </Button>
                </div>
            </div>
        </header>
    );
};
